import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, Ref, ref } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import {
    BorrowCalculatorInterface,
    BorrowCalculatorFields,
    CalculatorOptions,
    CalculatorOptionsFields,
  } from "@/types/BorrowCalculator";

  type propsType = {
    form: BorrowCalculatorInterface;
    formCalculatorOptions: CalculatorOptions;
  };
  const maxLoanTermAmount = 50;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorAboutYouSection',
  props: {
    form: {},
    formCalculatorOptions: {}
  },
  emits: ["updateForm", "updateFormCalculatorOptions"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;
  const loanTermAmount = ref<number[]>([]);
  const updateForm = (field: BorrowCalculatorFields, value: string) => {
    emits("updateForm", field.toString(), value);
  };

  const updateFormCalculatorOptions = (
    field: CalculatorOptionsFields,
    value: "1" | "2" | boolean
  ) => {
    emits("updateFormCalculatorOptions", field.toString(), value);
  };

  const fillLoanTermAmount = (amount: number) => {
    for (let i = 5; i <= amount; i = i + 5) {
      loanTermAmount.value.push(i);
    }
  };

  onMounted(() => {
    fillLoanTermAmount(maxLoanTermAmount);
  });

const __returned__ = { emits, props, loanTermAmount, maxLoanTermAmount, updateForm, updateFormCalculatorOptions, fillLoanTermAmount, computed, onMounted, Ref, ref, DropDown, get BorrowCalculatorInterface() { return BorrowCalculatorInterface }, get BorrowCalculatorFields() { return BorrowCalculatorFields }, get CalculatorOptions() { return CalculatorOptions }, get CalculatorOptionsFields() { return CalculatorOptionsFields } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})